import { useEffect, useRef, useState } from "react";

import { useDebounce } from "usehooks-ts";

import { TextInput, type TextInputProps } from "./text-input";

export interface DebouncedTextInputProps
  extends Omit<TextInputProps, "value" | "onChange"> {
  value: string;
  delay?: number;
  onChange: (value: string) => void;
}

export const DebouncedTextInput = ({
  value,
  delay = 500,
  onChange,
  ...props
}: DebouncedTextInputProps) => {
  const isInitialRef = useRef(true);
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const debouncedValue = useDebounce(localValue, delay);

  useEffect(() => {
    if (!isInitialRef.current) {
      onChange(debouncedValue);
    }

    isInitialRef.current = false;
  }, [debouncedValue]);

  return (
    <TextInput
      {...props}
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
    />
  );
};
